<template>
  <ParentNode
    :id="id"
    :source-connection-active="sourceConnectionActive"
    :target-connection-active="targetConnectionActive"
    :get-connected-elements="getConnectedElements"
    :get-connected-source-elements="getConnectedSourceElements"
    :main-node="true"
    :type="type"
    :data="data"
    :dimensions="dimensions">
    <template #body>
      <div
        :style="{ width: `${dimensions.w}px`, height: `${dimensions.h}px` }"
        class="items-center text-center flex font-light text-sm justify-center border bg-[#2B3C44] text-white rounded-md">
        {{ $t("MAIN") }}
      </div>
    </template>
  </ParentNode>
</template>

<script>
import ParentNode from "./ParentNode.vue"

export default {
  components: { ParentNode },
  props: {
    data: null,
    type: null,
    id: null,
    dimensions: null,
    sourceConnectionActive: null,
    targetConnectionActive: null,
    getConnectedElements: null,
    getConnectedSourceElements: null
  },
  emits: [],
  data() {
    return {}
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
